import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { userStore } from "../../redux/reduxStore.js";
import axios from "axios";
import { toast } from 'react-toastify';
import Testimonials from '../Testimonials.jsx';
import Loader from '../Loader.jsx';

const Changepassword = () => {
  const { register, handleSubmit, formState: {errors}, reset, watch } = useForm({ defaultValues: { oldPassword:"", newPassword:"", confirmPassword:""} }); 
  const newPassword = watch("newPassword");
  const [loader, setLoader] = useState(false);
  const handleChangePassword = (data) => {
    if (data.newPassword !== data.confirmPassword) {
      return toast("Confirm-Password do not match", {
        theme:"light",
        type:"warning",
        position:"top-right"
      });
    }
    setLoader(true);
    axios({
      method:"POST",
      url:`${process.env.REACT_APP_BASE_URL}/user/change-password`,
      headers: {
        "Content-Type":"application/json",
        "Authorization":`Bearer ${userStore.getState().token}`,
      },
      data: JSON.stringify({
        userId: userStore.getState().user?._id,
        oldPassword : data.oldPassword,
        newPassword : data.newPassword
      }),
    }).then(res => {
      setLoader(false);
      reset({ confirmPassword:"", newPassword:"", oldPassword:"" });
      return toast(res.data.message, {
        theme:"light",
        type:"success",
        position:"top-right"
      });
    }).catch(err => {
      setLoader(false);
      return toast( err?.response?.data?.message || err.message || "Change password was unsuccessful." ,{
        theme:"light",
        type:"error",
        position:"top-right",
      });
    });
  }
  return (
    <>
      <section className='form-section userform'>
        <Container>
          <Row className="justify-content-center">
            <Col xxl={5} lg={6} md={8} sm={10}>
              <div className="boxwrap">
                <h2 className='text-gradient'>Change Password</h2>
                <Form onSubmit={handleSubmit(handleChangePassword)} className="row">

                  <Form.Group as={Col} md="12" className="mb-3" controlId="changepassword-Password">
                    <Form.Label>Current password <span>*</span></Form.Label>
                    <Form.Control
                      type="password" placeholder='Please enter current password'
                      {...register("oldPassword", {
                        required: { message:"Old-Password is require", value:true },
                        pattern: { message:"Old-Password is not valid", value: /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/g }
                      })}/>
                      { errors.oldPassword ? <p className='errMsg'>{errors.oldPassword.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="changepassword-Password">
                    <Form.Label>New password <span>*</span></Form.Label>
                    <Form.Control
                      type="password" placeholder='Please enter new password'
                      {...register("newPassword", {
                        required: { message:"New-Password is require", value:true },
                        pattern: { message:"New-Password is too weak", value: /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/g }
                      })}/>
                      { errors.newPassword ? <p className='errMsg'>{errors.newPassword.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="changepassword-Password">
                    <Form.Label>Confirm new password <span>*</span></Form.Label>
                    <Form.Control
                      type="password" placeholder='Please reenter new password'
                      {...register("confirmPassword", {
                        required: { message:"Confirm-Password is require", value:true },
                        validate: (value) => {
                          if (value !== newPassword) {
                            return "Password do not match";
                          }
                          return true;
                        }
                      })}/>
                      { errors.confirmPassword ? <p className='errMsg'>{errors.confirmPassword.message}</p> : null }
                  </Form.Group>

                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <button onClick={() => reset({ confirmPassword:"", newPassword:"", oldPassword:"" })} type="button" className="button yellow w-50 py-3">Cancel</button>
                    <button type="submit" className="button blue w-50 py-3">Submit</button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader}/>
    </>
  )
}

export default Changepassword